// Chiavi stabili per le liste modificabili: l'indice dell'array non è affidabile quando le righe si spostano.
let counter = 0;

export const newRowId = () => `row_${(counter += 1)}_${Math.random().toString(36).slice(2, 7)}`;

export const withRowIds = rows => (rows || []).map(row => (row && row._uid ? row : { ...row, _uid: newRowId() }));

export const stripRowIds = rows => (rows || []).map(({ _uid, ...rest }) => rest);
